export const PROPERTY_TABLE_COLUMNS = [
  { id: 0, name: 'Block indicators' },
  { id: 1, name: 'Type' },
  { id: 2, name: 'Formula' },
  { id: 3, name: 'Help text' },
  { id: 4, name: 'Format' },
  { id: 5, name: 'Roll up type' },
  { id: 6, name: 'Display as output' },
  { id: 7, name: 'Display as sub-total' },
  { id: 8, name: 'Default chart type' },
] as const;

/** Client-only ids for blank “add indicator” rows (see `usePropertyTableInteractionController`). */
export function isBuilderPropertyDraftRowId(id: unknown): id is string {
  return typeof id === 'string' && id.startsWith('builder-property-draft-');
}
